module.exports = __webpack_public_path__ + "img/evo-izmaylovo.bb86d9ea.png";